import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div 
      className={cn(
        "relative overflow-hidden rounded-md",
        "bg-gradient-to-r from-muted via-muted/50 to-muted",
        "before:absolute before:inset-0",
        "before:bg-gradient-to-r before:from-transparent before:via-holographic-cyan/20 before:to-transparent",
        "before:animate-[skeleton-shimmer_2s_ease-in-out_infinite]",
        className
      )} 
      {...props} 
    />
  );
}

function SkeletonHolographic({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div 
      className={cn(
        "relative overflow-hidden rounded-md",
        "bg-gradient-to-br from-holographic-cyan/10 via-holographic-pink/10 to-holographic-cyan/10",
        "before:absolute before:inset-0",
        "before:bg-gradient-to-r before:from-transparent before:via-holographic-cyan/30 before:to-transparent",
        "before:animate-[skeleton-shimmer_2s_ease-in-out_infinite]",
        "animate-[holographic-pulse_3s_ease-in-out_infinite]",
        className
      )} 
      {...props} 
    />
  );
}

export { Skeleton, SkeletonHolographic };
